















import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { WidgetConfiguration } from "../interfaces/widgetConfiguration";
import { WidgetState } from "../interfaces/widgetState";
import { WidgetPayload } from "../interfaces/widgetPayload";
import { Layout } from "../interfaces/layout";
import WidgetGrid from "@/components/WidgetGrid.vue";
import BackgroundSettings from "@/interfaces/studioBackground";

@Component({
    components: {
        WidgetGrid,
    },
})
export default class ScriptBuilderPage extends Vue {
    @Prop() public fullscreenWidgetId!: string | null;
    @Prop() public layout!: Layout[];
    @Prop() public configurationIds!: string[];
    @Prop() public configurations!: WidgetConfiguration<
        WidgetState,
        WidgetPayload
    >[];
    @Prop() cssProps!: BackgroundSettings;

    public get usedConfigurations() {
        return this.configurations.filter(c =>
            this.configurationIds.includes(c.widgetId)
        );
    }

    @Emit() update(event: {
        config: WidgetConfiguration<WidgetState, WidgetPayload>;
        payload: WidgetPayload;
    }) {
        return event;
    }

    @Emit() fullscreen(event: { widgetId: string; fullscreen: boolean }) {
        return event;
    }

    @Emit() remove(widgetId: string) {
        return widgetId;
    }
}
